<app-vaccinate-member 
[activeStepIndex]="'VACCINATEMEMBER'" 
(onClose)="closeDialog()" (onStepChange)="onStepChange($event)">
</app-vaccinate-member>
